<template>
    <div class="item-position video-item">
      <div class="video-title disable-select">
        <div>{{craneName}}</div>
        <div>{{videoTitle}}</div>
        <div><img @click="close()" style="cursor: pointer" src="/static/img/close.png" width="20"/></div>
      </div>
      <div class="video-main">
        <video
          id="myPlayer"
          class="video-js vjs-big-play-centered"
        />
      </div>
    </div>
</template>

<script>
import videoJS from 'video.js'
import "video.js/dist/video-js.min.css";
export default {
  name: 'HLSVideo',
  data () {
    return {
      videoObj: null
    }
  },
  props: {
    addr: {
      type: String
    },
    videoTitle: {
      type: String
    },
    craneName: {
      type: String
    }
  },
  watch: {
    addr (val, oldVal) {
      if (val !== oldVal) {
        if (this.videoObj) {
          this.videoObj.pause();
          this.videoObj.src(val);
        }
      }
    }
  },
  methods: {
    close () {
      this.$emit('closeVideoDiv')
    }
  },
  mounted () {
    if (this.addr) {
      const _option = {
        controls: true,
        muted: true,
        autoplay: true, // 加载完成是否自动播放
        loop: false, // 视频播放结束后，是否循环播放
        preload: 'auto',
        width: 500,
        allowfullscreen: true,
        notSupportedMessage: '此视频暂无法播放，请稍后再试',
        controlBar: {
          progressControl: false, // 隐藏进度条
          volumePanel: false // 隐藏音量面板
        },
        disablePictureInPicture: true, // 禁用画中画功能
        sources: [{
          type: 'application/x-mpegURL',
          src: this.addr // 视频播放地址
        }]
      }
      // @ts-ignore
      const videoObj = videoJS(`myPlayer`, _option, () => {
      });
      // @ts-ignore
      videoObj.on('error', () => {
        console.log(123)
        // 若视频流断开，尝试重新播放
        videoObj.pause();
        videoObj.src(this.addr);
        videoObj.load();
        videoObj.play();
      });
      this.videoObj = videoObj
    }
  },
  destroyed () {
    if (this.videoObj) {
      this.videoObj.dispose()
    }
  }
}
</script>

<style scoped lang="scss">
  .video-item{
    z-index:999;
    width:500px;
    height:435px;
    left: 1100px;
    top: 20px;
    background-color: #252525;
    .video-title{
      height:35px;
      color:#ffffff;
      display: flex;
      justify-content: space-between;
      align-items: center;
      padding:0 10px;
    }
    .video-main{
      width:500px;
      height:400px;
      display: flex;
      justify-content: center;
      align-items: center;
      #myPlayer {
        width:500px;
        height:400px;
      }
    }
    .disable-select {
      -moz-user-select: none;
      -webkit-user-select:none;
      -ms-user-select:none;
      user-select:none;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/HLSVideo.vue